import React, { useState } from "react";
import CommonModalView from "presentational/common/modals/CommonModalView";
import DeleteAccountModalView from "presentational/portfolio/DeleteAccountModalView";
import ChangeItemVisibilityModalView from "presentational/portfolio/ChangeItemVisibilityModalView";
import TXT from "presentational/common/multinational/TXT";
import PropTypes from "prop-types";

SettingsModalView.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  tokenAuthType: PropTypes.PropTypes.oneOf(["google", "cognito_email"])
    .isRequired,
  preset: PropTypes.shape({
    isItemListPublic: PropTypes.bool
  }).isRequired,
  onProfileImgChangeClick: PropTypes.func.isRequired,
  onChangeUsernameBtnClick: PropTypes.func.isRequired,
  onChangePwBtnClick: PropTypes.func.isRequired,
  onSubmitAccountDeletion: PropTypes.func.isRequired,
  onItemOpenPresetSubmit: PropTypes.func.isRequired
};

function SettingsModalView(props) {
  const {
    open,
    onClose,
    tokenAuthType,
    preset,
    onProfileImgChangeClick,
    onChangeUsernameBtnClick,
    onChangePwBtnClick,
    onSubmitAccountDeletion,
    onItemOpenPresetSubmit
  } = props;
  const [deleteAccountModalOpen, setDeleteAccountModalOpen] = useState(false);
  const [changeItemVisibilityModalOpen, setChangeItemVisibilityModalOpen] =
    useState(false);

  const getButtonList = () => {
    const { isItemListPublic } = preset;

    return [
      {
        primary: <TXT name="btnList_changeUsername" />,
        secondary: null,
        func: onChangeUsernameBtnClick
      },
      {
        primary: <TXT name="btnList_changeProfileImg" />,
        secondary: null,
        func: onProfileImgChangeClick
      },
      tokenAuthType === "cognito_email" && {
        primary: <TXT name="btnList_changePassword" />,
        secondary: null,
        func: onChangePwBtnClick
      },
      {
        primary: <TXT name="btnList_itemVisibility" />,
        secondary: !!isItemListPublic ? (
          <TXT name="msg_nowPublic" />
        ) : (
          <TXT name="msg_nowPrivate" />
        ),
        func: handleChangeItemVisibilityBtnClick
      },
      {
        divider: true
      },
      {
        primary: <TXT name="btnList_deleteAccount" />,
        secondary: null,
        func: handleDeleteAccountBtnClick
      }
    ].filter(Boolean);
  };

  const closeDeleteAccountModal = () => {
    setDeleteAccountModalOpen(false);
  };

  const closeChangeItemVisibilityModal = () => {
    setChangeItemVisibilityModalOpen(false);
  };

  const handleDeleteAccountBtnClick = () => {
    onClose();
    setDeleteAccountModalOpen(true);
  };

  const handleDeleteAccountModalClose = () => {
    closeDeleteAccountModal();
  };

  const handleChangeItemVisibilityBtnClick = () => {
    onClose();
    setChangeItemVisibilityModalOpen(true);
  };

  const handleChangeItemVisibilityModalClose = () => {
    closeChangeItemVisibilityModal();
  };

  const handleAccountDeletionConfirm = () => {
    closeDeleteAccountModal();
    onSubmitAccountDeletion();
  };

  const handleItemOpenPresetSubmit = async value => {
    await onItemOpenPresetSubmit(value);
    closeChangeItemVisibilityModal();
  };

  return (
    <div>
      <CommonModalView
        open={open}
        onClose={onClose}
        titleText={<TXT name="titleModal_settings" />}
        buttonList={getButtonList()}
        firstButtonText={<TXT name="btnModal_close" />}
        firstButtonFunc={onClose}
      />
      <DeleteAccountModalView
        open={deleteAccountModalOpen}
        onClose={handleDeleteAccountModalClose}
        onAccountDeletionConfirm={handleAccountDeletionConfirm}
      />
      <ChangeItemVisibilityModalView
        open={changeItemVisibilityModalOpen}
        onClose={handleChangeItemVisibilityModalClose}
        onItemOpenPresetSubmit={handleItemOpenPresetSubmit}
        isItemListPublic={preset.isItemListPublic}
      />
    </div>
  );
}

export default SettingsModalView;
